// src/config/firebase.ts
import { initializeApp, getApps } from 'firebase/app';
import { ENV } from './env';

let instance: ReturnType<typeof initializeApp> | null = null;

export const getFirebase = (): ReturnType<typeof initializeApp> | null => {
  if (typeof window === 'undefined') return null;
  
  try {
    if (instance) return instance;
    
    const config = ENV.getFirebaseConfig();
    
    // Validate config
    if (!config.apiKey) {
      console.error('Firebase config is missing apiKey');
      return null;
    }
    
    instance = getApps().length === 0 ? initializeApp(config) : getApps()[0];
    return instance;
  } catch (error) {
    console.error('Firebase initialization error:', error);
    return null;
  }
};